exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cursor[data-v-087e86d9] {\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
